import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ValidatedTextInput } from '../../../__legacy__/components/ValidatedTextInput';
import { ButtonWithLoader } from '../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../design/modals/modal/S_Modal';
import { IWorkspace } from '../admin.store';

interface IProps {
  isOpened: boolean;
  workspace: IWorkspace | null;
  onCanceled: () => void;
  onConfirmed: () => Promise<void>;
  onChange: (value: string) => void;
  showSpinner: boolean;
}

export const ChangeWorkspaceCostLimitModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  if (!props.workspace) {
    return <></>;
  }

  return (
    <S_Modal
      isOpen={props.isOpened}
      toggle={props.onCanceled}
      headerText={t('modal.change_workspace_cost_limit.header')}
      buttons={
        <>
          <Button
            id='change-button-cancel'
            color='neutral'
            variant='outlined'
            onClick={props.onCanceled}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            id='change-button'
            color='primary'
            onClick={() => {
              void props.onConfirmed();
            }}
            disabled={!props.workspace.cloudCostsLimit.toString(10)}
            loading={props.showSpinner}
          >
            {t('submit')}
          </ButtonWithLoader>
        </>
      }
    >
      <ValidatedTextInput
        type='text'
        value={props.workspace.cloudCostsLimit}
        labelText={t('modal.change_workspace_cost_limit.label')}
        placeholder=''
        onChange={props.onChange}
      />
    </S_Modal>
  );
});
